<template>
	<v-overlay :dark="false" :value="showModal">
		<div class="input-modal warning-modal">
			<div class="input-modal-header warning-modal-header">
				<h1 class="input-modal-header-title warning-modal-title">Are You Sure?</h1>
				<v-btn icon @click="$emit('cancel')">
					<v-icon v-text="'mdi-close'"></v-icon>
				</v-btn>
			</div>
			<div class="input-modal-content">
				<div class="warning-modal-message">
					{{ message }}
				</div>

				<ul v-if="itemList.length > 0" class="warning-modal-list">
					<li v-for="(item, i) in itemList" :key="i">
						{{ item[itemListKey] }}
					</li>
				</ul>

				<div class="input-modal-content-actions">
					<v-btn v-if="!onlyShowConfirmOption" outlined depressed @click="$emit('cancel')">{{
						cancelText
					}}</v-btn>
					<v-btn color="primary" depressed @click="$emit('confirm')">{{ confirmText }}</v-btn>
				</div>
			</div>
		</div>
	</v-overlay>
</template>

<script>
export default {
	name: "WarningModal",
	props: {
		showModal: {
			type: Boolean,
			default: false,
		},
		message: {
			type: String,
			default: "",
		},
		cancelText: {
			type: String,
			default: "Cancel",
		},
		confirmText: {
			type: String,
			default: "Yes",
		},
		itemList: {
			type: Array,
			default() {
				return [];
			},
		},
		itemListKey: {
			type: String,
		},
		onlyShowConfirmOption: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
.v-overlay {
	::v-deep {
		.v-overlay__content {
			width: 95%;
		}
	}

	&-relative {
		position: relative;
		padding: 3rem 0;
		width: 100%;
	}
}

.warning-modal {
	max-width: 55rem;

	&-title {
		font-weight: 700;
	}

	&-message {
		font-size: 1.6rem;
		text-align: center;
	}

	&-list {
		list-style: none;
		text-align: center;
		font-weight: 700;
		padding-left: 0;
		margin-top: 1rem;
	}
}
</style>
